/**
 * CSS spinner used for inline or absolute loading placeholders.
 *
 * @param {object} props
 * @param {boolean} [props.abs] - When true, positions the loader absolutely within its parent
 * @param {string} [props.className]
 */
const Loader = ({ abs, className, ...props }) => {
  return (
    <div
      className={`loading ${abs ? 'abs' : ''} ${className || ''}`}
      data-testid="loader-component"
      {...props}
    />
  )
}

export default Loader
